import { createRouter, createWebHistory } from 'vue-router'
import routes from './routes'
import { useAuthStore } from '@/stores/auth'

const router = createRouter({
  history: createWebHistory(),
  routes,
})

const studentRoutes = [
  'student-my-page',
  'ticket-management',
  'subscription-management',
  // LMS（生徒導線）
  'student-lms-courses',
  'student-lms-course',
  'student-lms-lesson',
  'student-lms-quiz',
  'student-lms-grades',
  'student-lms-feedback',
]
const adminRoutes = [
  'admin-student-management',
  'admin-teacher-management',
  'admin-student-detail',
  'admin-teacher-detail',
  'admin-policy-management',
  // LMS（管理者導線）
  'admin-lms-courses',
  'admin-lms-course',
  'admin-lms-quiz-new',
  'admin-lms-quiz-edit',
  'admin-lms-enrollments',
  'admin-lms-users',
  'admin-lms-teachers',
  'admin-lms-students',
  'admin-lms-feedback',
  // LMSメッセージ（フェーズ0・完全隔離モック）: 直URLでも admin ロール必須にする
  'admin-lms-messages',
  // 採用試験（管理者導線・追加のみ）: admin ロール必須
  'admin-recruit-applicants',
  'admin-recruit-applicant-detail',
  'admin-recruit-attempts',
  'admin-recruit-attempt-grading',
  'admin-recruit-exam-editor',
]
const teacherRoutes = [
  'teacher-list-student',
  'teacher-my-page',
  'teacher-detail-student',
  // LMS（講師導線）
  'teacher-lms-courses',
  'teacher-lms-course',
  'teacher-lms-quiz-new',
  'teacher-lms-quiz-edit',
  'teacher-lms-students',
  'teacher-lms-feedback',
]
const requireLogoutRoutes = [
  'signin',
  'signup',
  'forgot-password',
  'reset-password',
]

const loginPath = '/'
const homeStudentPath = '/student/me'
const homeAdminPath = '/admin/students'
const homeTeacherPath = '/teacher/me'

router.beforeEach(async (to) => {
  const { user, getAuthUser, role } = useAuthStore()
  if (role && !user) {
    try {
      await getAuthUser()
    } catch {
      return loginPath
    }
  }

  if (requireLogoutRoutes.includes(to.name)) {
    if (role == 'user') return homeStudentPath
    if (role == 'teacher') return homeTeacherPath
    if (role == 'admin') return homeAdminPath
  }

  if (studentRoutes.includes(to.name)) {
    if (role !== 'user') return '/'
  }
  if (adminRoutes.includes(to.name)) {
    if (role !== 'admin') return '/'
  }
  if (teacherRoutes.includes(to.name)) {
    if (role !== 'teacher') return '/'
  }

})

export default router
